// eslint-disable-next-line no-extend-native,func-names
String.prototype.reverse = function () {
  return this.split('').reverse().join('');
};
